<template>
  <div>
    <div class="form-group" :class="{'-has-error': errors.businessName.length > 0}">
      <label for="business-name" class="label">Nome da Empresa</label>
      <input
        class="form-control"
        id="business-name"
        type="text"
        placeholder="Nome da Empresa"
        v-model="form.businessName"
        required
      >
      <p class="description" v-if="errors.businessName.length > 0">{{ errors.businessName[0] }}</p>
    </div>

    <div class="form-group" :class="{'-has-error' : errors.cnpj.length > 0}">
      <label for="cnpj" class="label">
        CNPJ da Empresa
      </label>
      <input
        class="form-control"
        id="cnpj"
        type="text"
        placeholder="CNPJ"
        v-mask="'##.###.###/####-##'"
        v-model="form.cnpj"
        required
      >
      <p class="description" v-if="errors.cnpj.length > 0">{{ errors.cnpj[0] }}</p>
    </div>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';

export default {
  name: 'BusinessInformations',

  props: {
    errors: Object,
    form: Object,
  },

  directives: {
    mask,
  },

  mounted() {
    this.$el.querySelector('input').focus();
  },
};
</script>
